import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { trackEvent } from "../../analytics";
import { ANALYTICS } from "../../lib/analyticsEvents";
import {
  guestLoginHref,
  getKitaLandingCopy,
} from "../../lib/guestAcquisition";
import SchoolEmailDemo from "../SchoolEmailDemo/SchoolEmailDemo";
import "../../pages/SchoolInboxPage.css";
import "./SchoolEmailGuestPreview.css";

export default function SchoolEmailGuestPreview() {
  const [searchParams] = useSearchParams();
  const utmScenario = searchParams.get("utm_scenario");
  const copy = getKitaLandingCopy(utmScenario);
  const loginHref = guestLoginHref(utmScenario);

  React.useEffect(() => {
    if (!utmScenario) return;
    trackEvent(ANALYTICS.kita_landing_view, { scenario: utmScenario });
  }, [utmScenario]);

  return (
    <div className="school-guest-page">
      <header className="school-guest-header">
        <h2 className="school-inbox-title">{copy.title}</h2>
        <p className="school-guest-lead">{copy.lead}</p>
      </header>

      <SchoolEmailDemo />

      <div className="school-guest-actions">
        <Link
          to={loginHref}
          className="school-btn school-btn--primary school-guest-cta"
          onClick={() =>
            trackEvent(ANALYTICS.school_guest_cta, { source: "schule_preview" })
          }
        >
          {copy.cta}
        </Link>
        <Link to="/" className="school-guest-secondary">
          Albis im Chat
        </Link>
      </div>

      <details className="school-guest-setup">
        <summary className="school-guest-setup-summary">
          So richte ich das ein
        </summary>
        <ol className="school-setup-steps">
          <li>Anmelden und Adresse kopieren</li>
          <li>Eine Eltern-Mail weiterleiten — oder ein Foto vom Flyer im Chat</li>
          <li>Termine im Chat — Erinnerung und Kalender mit einem Tipp</li>
        </ol>
      </details>
    </div>
  );
}
